import React from "react"
import { Container, Breadcrumb, BreadcrumbItem } from "reactstrap"
import Layout from "./../components/layout"
import SEO from "./../components/seo"

function About() {
  return (
    <Layout>
      <SEO />
      <Breadcrumb className="breadCrumb">
        <BreadcrumbItem>
          <a className="breadCrumbLinks" href="/">
            Home
          </a>
        </BreadcrumbItem>
        <BreadcrumbItem active>About</BreadcrumbItem>
      </Breadcrumb>
      <Container>
        <h1>About</h1>
        <p>
          Our Corporations, International Software Products (ISP), a Canadian
          Corporation, and International Software Products Inc. (ISPI) of the
          United States of America are privately held companies with affiliate
          offices located world wide. The corporations were founded in 1987 and
          1990 respectively to properly service the needs of our North American
          clients.
        </p>
        <p>
          Combined skills enable us to provide expertise in all facets of
          commercial data processing including mainframe, minicomputer and
          microcomputer systems. Our software expertise ranges from routine
          business applications to the more esoteric systems and programming
          functions.
        </p>
        <p>The company consists of three divisions:</p>
        <ul>
          <li>
            <strong>Software Products</strong> - Responsible for development,
            support, maintenance and enhancement of the current software product
            line as well as liaison with partner software developers. This group
            is also responsible for developing new products and acquiring,
            testing and modifying where necessary, other products available in
            the international community.
          </li>
          <li>
            <strong>Marketing</strong> - Markets the Products and Services to
            exploit our software and technical expertise and is the link between
            the ISP companies and their international partner network.
          </li>
          <li>
            <strong>Consulting</strong> - Provides the services of professional
            consultants on a contractual basis to clients in the public and
            private sector within North America and abroad. The Consulting
            Division offers a complete System Optimization process, attained
            through Performance Management and Capacity Planning; DataWarehouse
            design and implementation; plus general IT consulting at all levels.
            We offer these services both on and/or off-site as determined by the
            client.
          </li>
        </ul>
        <p>
          The directors and management of the firm are senior systems consulting
          professionals dedicated to making a significant contribution to the
          overall success and well-being of each client's operation.
        </p>
        <p>
          Corporate policy directs us to seek and exploit existing software
          solutions before resorting to new software development. This policy is
          our most important asset next to our people, and our people have been
          selected from a cross-section of government and industry with
          extensive experience in resolving business problems using computers.
        </p>
        <p>
          Our Product Line currently represents software developed within North
          America and across the world including Europe and Australia. Once we
          find that software, we test it in the North American environment. Only
          when we are satisfied that it will perform as claimed, do we make it
          available to our clients with a significant value-added benefit --{" "}
          <strong>ISP Technical Support</strong>
        </p>
      </Container>
    </Layout>
  )
}

export default About
